//context
import { useContext, useEffect, useState } from 'react';
import { ActivityFeedContext } from '@/context/ActivityFeedContext';

//helpers
import { formatActivityTime, formatLongDateGroup, getActiveParentList, getAppDetails, getContentDetails, getParentListDetails, getUniqueActivityKey, getUserDetails } from  '@/helpers/ActivityFeed';

//interfaces
import { IActivityProps, UserActivity } from  '@/interfaces/activityFeed';

//components
import CommentReply from '../notifications/CommentReply/CommentReply';
import CommentLike from '../notifications/CommentLike/CommentLike';
import CommentPost from '../notifications/CommentPost/CommentPost';
import { IMeta } from  '@/interfaces/activityFeedNotifications';



const CommentActivity = ({zIndexNum, isPopOut, activity: {author, contentItem, comment, parentLists, createdAt, activityType, workspace, meta}} : IActivityProps) => { 
    const { replyToComment, likeComment, deleteComment, getNotification, getOpenOnWebLink, isMultipleAppOrganisation, userProfileImage} = useContext(ActivityFeedContext);
    const activeParentList = getActiveParentList(parentLists);
    const id = getUniqueActivityKey(activityType, contentItem.id, createdAt, author?.id)
    const notificationDetails = getNotification(id) ?? undefined;
    const webLink = comment?.isDeleted ? () => getOpenOnWebLink(contentItem.id) : () => getOpenOnWebLink(contentItem.id, comment.id);
    const [contentMeta, setContentMeta] = useState(meta);
    
    useEffect(() => {
        setContentMeta(meta);
    }, [meta]);

    function handleCommentLike(){
        setContentMeta((prev: IMeta) => {
            const updated = {
                ...prev,
                likeCount: prev.hasLiked ? prev.likeCount - 1 : prev.likeCount + 1,
                hasLiked: !prev.hasLiked
            };

            likeComment(id, workspace.id, contentItem.id, comment.id, prev.hasLiked);

            return updated;
        });
    }
    
    if (activityType === UserActivity.comment) { 
        return (
            <CommentPost 
                zIndexNum = {zIndexNum}
                key={id}
                activityId={id}
                isPopOut={isPopOut}
                timeStamp={formatActivityTime(createdAt)} 
                dateStamp={formatLongDateGroup(createdAt)}
                user={getUserDetails(author)} 
                content={getContentDetails(contentItem, activeParentList, workspace, parentLists?.length > 1)}    
                meta={contentMeta}
                parentList={getParentListDetails(activeParentList, workspace)} 
                appDetails={getAppDetails(workspace, isMultipleAppOrganisation)} 
                editorProfileImage={userProfileImage} 
                onLikeClick={handleCommentLike} 
                onPostCommentClick={replyToComment} 
                getOpenOnWebLink={webLink}                      
                notificationDetails={notificationDetails}
                onDeleteCommentClick={deleteComment} 
                comment={comment}
            />
        )
    }

    else if (activityType === UserActivity.commentLike) { 
        return (
                <CommentLike
                    zIndexNum = {zIndexNum}
                    key={id}
                    activityId={id}
                    isPopOut={isPopOut}
                    timeStamp={formatActivityTime(createdAt)}
                    dateStamp={formatLongDateGroup(createdAt)}
                    user={getUserDetails(author)} 
                    content={getContentDetails(contentItem, activeParentList, workspace, parentLists?.length > 1)}
                    comment={comment}
                    appDetails={getAppDetails(workspace, isMultipleAppOrganisation)} 
                    commentAuthor={getUserDetails(comment.originalCommentAuthor)}
                    getOpenOnWebLink={webLink}                      
                    notificationDetails={notificationDetails}
                />
        )
    }

    else if (activityType === UserActivity.commentReply) { 
        return (
                <CommentReply 
                    zIndexNum = {zIndexNum}
                    key={id}
                    activityId={id}
                    isPopOut={isPopOut}
                    timeStamp={formatActivityTime(createdAt)} 
                    dateStamp={formatLongDateGroup(createdAt)}
                    user={getUserDetails(author)} 
                    commentAuthor={getUserDetails(comment.originalCommentAuthor)} 
                    content={getContentDetails(contentItem, activeParentList, workspace, parentLists?.length > 1)}    
                    comment={comment}
                    originalCommentText={comment.originalText} 
                    appDetails={getAppDetails(workspace, isMultipleAppOrganisation)} 
                    onDeleteCommentClick={deleteComment}  
                    getOpenOnWebLink={webLink}     
                    meta={contentMeta}                 
                    parentList={getParentListDetails(activeParentList, workspace)} 
                    notificationDetails={notificationDetails}
                    onLikeClick={handleCommentLike} 
                />
        )
    }
                    
    return null; 
}
export default CommentActivity



